import { AppId } from '@inno-tools/container-bridge'
import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { containerApi } from '../..'
import { UnpinAppResponse } from './unpinApp.types'

export const unpinApp = async (appId: AppId) => {
  const response = await containerApi.delete<UnpinAppResponse>(
    `/desktop/pinned-apps/${appId}`
  )
  return response.data
}

export const useUnpinAppMutation = (
  options?: ExtendableMutationOptions<UnpinAppResponse, AppId>
) => {
  return useMutation({
    mutationFn: unpinApp,
    ...options
  })
}
